import _extends from "@babel/runtime/helpers/extends";
import cx from "classnames";
import React from "react";
import { Caption, InlineText, Label } from "../Typography";
import { FormField } from "../internal/FormField";
export const FormGroup = _ref => {
  let {
    alert,
    error,
    danger = error,
    caption = danger || alert || undefined,
    className,
    children,
    hint,
    htmlFor,
    label,
    layout = "default",
    required,
    toolbar,
    variant = danger ? "danger" : alert ? "alert" : "default",
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(FormField.Root, _extends({
    className: cx("TombacFormGroup", className),
    layout: layout
  }, rest), label && /*#__PURE__*/React.createElement(FormField.LabelArea, null, typeof label === "string" ? /*#__PURE__*/React.createElement(Label, {
    htmlFor: htmlFor,
    required: required,
    variant: variant
  }, label) : label), hint && /*#__PURE__*/React.createElement(FormField.HintArea, null, typeof hint === "string" ? /*#__PURE__*/React.createElement(Caption, {
    variant: "secondary"
  }, hint) : hint), toolbar && /*#__PURE__*/React.createElement(FormField.ToolbarArea, null, typeof toolbar === "string" ? /*#__PURE__*/React.createElement(InlineText, null, toolbar) : toolbar), /*#__PURE__*/React.createElement(FormField.ContentArea, null, children), caption && /*#__PURE__*/React.createElement(FormField.CaptionArea, null, typeof caption === "string" ? /*#__PURE__*/React.createElement(Caption, {
    variant: variant
  }, caption) : caption));
};
//# sourceMappingURL=FormGroup.js.map